import { NgModule } from '@angular/core';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from './modal.component';
import { CustomModalFooterDirective, ModalFooterComponent } from './modal-templates/modal-footer.component';
import { CustomModalBodyDirective, ModalBodyComponent } from './modal-templates/modal-body.component';
import { CustomModalHeaderDirective, ModalHeaderComponent } from './modal-templates/modal-header.component';
import { ButtonModule } from '@backbase/ui-ang/button';
import { IconModule } from '@backbase/ui-ang/icon';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';

/**
 * Angular module that provides modal dialog functionality and components.
 *
 * @remarks
 * Exports all modal-related components including {@link ModalComponent}, modal header, body, and footer components.
 * Also provides custom directive support for template projection within modal parts.
 * Includes necessary dependencies like ng-bootstrap modal, accessibility, and UI components.
 *
 * @example
 *
 * ```typescript
 * import { ModalModule } from '@backbase/ui-ang/modal';
 *
 * @NgModule({
 *   imports: [ModalModule],
 *   // ... other module configuration
 * })
 * export class AppModule {}
 * ```
 */
@NgModule({
  imports: [ButtonModule, IconModule, NgbModalModule, NgTemplateOutlet, NgComponentOutlet],
  declarations: [
    ModalComponent,
    ModalFooterComponent,
    CustomModalFooterDirective,
    ModalBodyComponent,
    CustomModalBodyDirective,
    ModalHeaderComponent,
    CustomModalHeaderDirective,
  ],
  exports: [
    ModalComponent,
    ModalFooterComponent,
    CustomModalFooterDirective,
    ModalBodyComponent,
    CustomModalBodyDirective,
    ModalHeaderComponent,
    CustomModalHeaderDirective,
  ],
})
export class ModalModule {}
